export default __webpack_public_path__ + "static/lifeprint-archit-2-d650d2d7e87ee453f4e1c4eb4e6c16f8.webp";